<template>

    <subproducto-form :idBusiness="idBusiness" :idSubproducto="idSubproducto" :filtro="filtro" :pag="pag" :idProveedor="idProveedor"
                      :ultimaCategoria="ultimaCategoria" :ultimoProveedor="ultimoProveedor" :SpProv="SpProv" :NomProveedor="NomProveedor"
                      :ultimaCasa="ultimaCasa"></subproducto-form>
</template>

<script>

    import SubproductoForm from '../../../Widgets/Subproductos/SubproductoForm.vue'
    import swal from 'sweetalert2'
    export default {

        components: {
            SubproductoForm
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                idSubproducto: this.$route.params.idSubproducto,
                pag: this.$route.params.pag,
                ultimaCategoria: this.$route.params.ultimaCategoria,
                ultimoProveedor: this.$route.params.ultimoProveedor,
                ultimaCasa: this.$route.params.ultimaCasa,
                filtro: this.$route.params.filtro,
                SpProv: this.$route.params.SpProv,
                NomProveedor: this.$route.params.NomProveedor,
                idProveedor: this.$route.params.idProveedor,
            }
        },
        created() {
            let action = this.idSubproducto ? this.$t("editar") : this.$t('nueva');
            this.$store.dispatch('setNameRoute', action +' ' + this.$i18n.t("materiaPrima"))

            this.getRestrictions();
        },

        methods: {

            getRestrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness,
                        idRestriction: 9,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByTipo", config)
                    .then(function (response) {

                        if (!response.data.response) {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.$router.push({
                                name: 'configuracion'
                            })

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            }


        },


    }


</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Subproductos/Subproducto.vue